<template>
  <button
    v-if="reviewItem.pdfFile?.path"
    v-tooltip="'Full view'"
    class="bg-light-neutral-500 h-7.5 w-7.5 p-1.5 rounded-full transition-transform duration-200 hover:scale-130"
    @click.stop="goToFullView"
  >
    <PdfIcon class="h-4 w-4 text-red-500" />
  </button>
  <button
    v-else
    v-tooltip="'Drag and drop or click to upload a PDF'"
    class="bg-light-neutral-500 p-1.5 rounded-full transition-transform duration-200 hover:scale-130 border border-primary-500 border-dashed"
    @click.stop="emit('triggerUpload')"
  >
    <PdfIcon class="h-6 w-6 text-slate-500" />
  </button>
</template>

<script setup lang="ts">
import PdfIcon from '@app/components/Icons/PdfIcon.vue'
import { RouteName } from '@app/router'
import { ReviewItem } from '@core/domain/models/reviewItem.model'
import { useRoute, useRouter } from 'vue-router'

const { reviewItem } = defineProps<{
  reviewItem: ReviewItem
}>()

const emit = defineEmits<{
  (e: 'triggerUpload'): void
}>()

const router = useRouter()
const route = useRoute()
function goToFullView() {
  let activeStep = 'screening'
  if (route.name === RouteName.REVIEW_EXECUTE_DATA_EXTRACTION)
    activeStep = 'extraction'
  else if (route.name === RouteName.REVIEW_EXECUTE_APPRAISAL)
    activeStep = 'appraisal'

  router.push({
    name: 'Review - Review Item',
    params: { reviewItemId: reviewItem.id },
    query: { step: activeStep },
  })
}
</script>
